export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";
export const SET_NAVIGATION_CONFIG = "SET_NAVIGATION_CONFIG";